module.exports = __webpack_public_path__ + "img/logo-academy.d5635648.svg";